<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;">
    </div>
    <div class="columns" v-show="showList">
        <div class="column">
          <section class="hero is-info" v-show="showList">
            <div class="hero-body">
              <div class="container">
                <h1 class="title is-4">
                  User List
                </h1>
              </div>
            </div>
            <article class="message" v-show="!dataAlready">
              <div class="message-body">กำลังดึงข้อมูล...</div>
            </article>
            <table class="table" style="width:100%" v-show="dataAlready">
            <thead>
              <tr>
                <th><abbr title="UserId">ID</abbr></th>
                <th><abbr title="displayName">Name</abbr></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="car in carList" v-bind:key="car.id">
                <td>{{car.userId}}</td>
                <td>{{car.displayName}}</td>
              </tr>
            </tbody>
          </table>
          </section>
        </div>
    </div>
  </div>
</template>
<style>
.banner {
  text-align: center;
  background-color: #000;
}
.error {
  color: red;
}
</style>
<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'Progress',
  beforeCreate () {
  },
  components: {
    QrcodeVue
  },
  data: () => ({
    showComplete: false,
    dataAlready: false,
    confirmSuccess: false,
    showList: true,
    branch: [],
    branchSelected: '',
    branchCode: '',
    carId: '',
    carList: []
  }),
  mounted () {
    let _this = this
    _this.getCarList()
  },
  methods: {
    getCarList () {
      let _this = this
      this.$axios
        .get(`${this.$apiUrl}getUserAll`)
        .then(response => {
          _this.dataAlready = true
          _this.carList = response.data
          _this.showList = true
        })
    },
    closeWindow () {
      this.$liff.closeWindow()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/User.vue